import { get, post } from '@/utils/request'

export const updateUser = data => post('/user/updateUser', data)

export const newUpdateUser = data => post('/user/newUpdateUser', data)

/* 获取优惠券列表 */
export const getDiscountCouponListByUserId = () => get(`/user/getDiscountCouponListByUserId`)

/* 领取优惠券 */
export const receiveDiscountCoupon = (data) => post('/user/receiveDiscountCoupon', data)

/* 获取用户优惠券列表 */
export const getUserCouponListByUserId = () => get(`/user/getUserCouponListByUserId`)

/* 获取用户优惠券数量 */
export const getUserCouponCountByUserId = () => get(`/user/getUserCouponCountByUserId`)



// WEBPACK FOOTER //
// ./src/api/user.js